function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg width="15" height="15" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M8.785 15c-.131 0-.327-.063-.458-.125l-2.68-2.25a.692.692 0 0 1-.196-.5V7.437L.156 1A.465.465 0 0 1 .091.375C.156.125.418 0 .68 0h13.66c.262 0 .458.125.589.375.13.188.065.5-.066.688L9.438 7.5v6.875c0 .25-.13.438-.392.563-.065.062-.13.062-.261.062z" fill="#278C7E" /></svg>;
});